export const STORE_NAME = 'productive';
export const CLIENT_AUTHORIZATION = process.env.CLIENT_AUTHORIZATION;
export const MERCHANT_ID = process.env.MERCHANT_ID;
export const MERCHANT_PAYPAL_ID = process.env.MERCHANT_PAYPAL_ID;
export const ENVIRONMENT = process.env.ENVIRONMENT;
